import $ from 'jquery';
import Swiper from 'swiper';
import Navigation from 'swiper/modules/navigation.mjs';
import Pagination from 'swiper/modules/pagination.min.mjs';
import Autoplay from 'swiper/modules/autoplay.min.mjs';
import Thumbs from 'swiper/modules/thumbs.mjs';



 const swiperThumbs = new Swiper(".mySwiper", {
  modules: [Navigation],
  spaceBetween: 10,
  slidesPerView: 2,
  freeMode: true,
  watchSlidesProgress: true,
  breakpoints: {
      '600': {
        slidesPerView: 3,
      },
      '980': {
        slidesPerView: 4,
      },
  }
});
const swiperMain = new Swiper(".mySwiper2", {
  modules: [Navigation, Thumbs],
  loop: true,
  spaceBetween: 10,

  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },

  thumbs: {
    swiper: swiperThumbs,
  },
});
const op__slide = new Swiper(".op__slide", {
  modules: [Autoplay,Pagination,Navigation],
  loop: true,
  speed: 600,
  slidesPerView: 1,
  spaceBetween: 20,
  autoplay: {
      delay: 7000,
      disableOnInteraction: false,
  },
  navigation: {
    prevEl: '.swiper-button-next-op',
    nextEl: '.swiper-button-prev-op',
  },
  breakpoints: {
      '600': {
        slidesPerView: 2,
      },
      '980': {
        slidesPerView: 1,
      },
      '1440': {
        slidesPerView: 1.5,
      },
  }
});





const wywslide__slider = new Swiper(".za__row", {
  modules: [Autoplay, Navigation, Pagination],
  speed: 1000,
  spaceBetween: 10,
  loop: true,
  slidesPerView: 2,
  autoplay: {
      delay: 6000,
      disableOnInteraction: false,
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true, 
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    '600': {
      slidesPerView: 2,
    },
    '980': {
      slidesPerView: 3,
    },
    '1110': {
      slidesPerView:4,
    },
    '1440': {
      slidesPerView: 6,
    },
}
});
const case__row = new Swiper(".case__row", {
  modules: [Autoplay, Navigation, Pagination],
  speed: 1000,
  spaceBetween: 15,
  loop: true,
  slidesPerView: 1,
  autoplay: {
      delay: 6000,
      disableOnInteraction: false,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    '720': {
      slidesPerView: 2,
    },
    '1110': {
      slidesPerView:2,
    },
    '1440': {
      slidesPerView: 3,
    },
}
});